import { NavListItem, NavListSectionHeader } from "#root/components/nav-list";
import type { ReactNode } from "react";
import { Fragment } from "react";
import { MdOutlineDescription } from "react-icons/md";
import { NavLink } from "react-router-dom";
import Layout from "../layout";

export type ParserElementsProps = Parameters<typeof Layout>["0"] & {
  feedElements?: ReactNode;
  journalElements?: ReactNode;
}

export default function (props: ParserElementsProps): ReactNode {
  return (
    <Layout
      {...props}
      parserElements={
        <Fragment>
          <NavListSectionHeader>NewsRPM Parser</NavListSectionHeader>
          <NavLink to="/admin/platform/newsrpm-parser/journal">
            <NavListItem icon={MdOutlineDescription}>Journal</NavListItem>
            {props.journalElements}
          </NavLink>
          <NavLink to="/admin/platform/newsrpm-parser/feed">
            <NavListItem icon={MdOutlineDescription}>Feeds</NavListItem>
            {props.feedElements}
          </NavLink>
        </Fragment>
      }
    />
  );
}
